
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import moment from 'moment'
import VueCookie from 'vue-cookie'
Vue.prototype.moment = moment
Vue.use(VueCookie)
// import FBSignInButton from 'vue-facebook-signin-button'
// Vue.use(FBSignInButton)

Vue.config.productionTip = false
/* eslint-disable no-new */
new Vue({
  el: '#app',
  created: function () {
    // @segment
    // eslint-disable-next-line
		!function () {
      var analytics = window.analytics = window.analytics || []; if (!analytics.initialize) {
        if (analytics.invoked) window.console && console.error && console.error('Segment snippet included twice.'); else {
          analytics.invoked = !0; analytics.methods = ['trackSubmit', 'trackClick', 'trackLink', 'trackForm', 'pageview', 'identify', 'reset', 'group', 'track', 'ready', 'alias', 'debug', 'page', 'once', 'off', 'on']
          analytics.factory = function (t) {
            return function () {
              var e = Array.prototype.slice.call(arguments); e.unshift(t)
              analytics.push(e); return analytics
            }
          }; for (var t = 0; t < analytics.methods.length; t++) { var e = analytics.methods[t]; analytics[e] = analytics.factory(e) } analytics.load = function (t, e) { var n = document.createElement('script'); n.type = 'text/javascript'; n.async = !0; n.src = (document.location.protocol === 'https:' ? 'https://' : 'http://') + 'cdn.segment.com/analytics.js/v1/' + t + '/analytics.min.js'; var o = document.getElementsByTagName('script')[0]; o.parentNode.insertBefore(n, o); analytics._loadOptions = e }; analytics.SNIPPET_VERSION = '4.1.0'
          analytics.load(process.env.SEGMENT_KEY)
          analytics.page()
          // eslint-disable-next-line
				}
      }
    }()

    //
    // window.intercomSettings = {
    //   app_id: 'hcfg0b7q'
    // };
    //
    // // eslint-disable-next-line
    // (function(){var w=window;var ic=w.Intercom;if(typeof ic==="function"){ic('reattach_activator');ic('update',intercomSettings);}else{var d=document;var i=function(){i.c(arguments)};i.q=[];i.c=function(args){i.q.push(args)};w.Intercom=i;function l(){var s=d.createElement('script');s.type='text/javascript';s.async=true;s.src='https://widget.intercom.io/widget/hcfg0b7q';var x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s,x);}if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}}})()

    // @fb
    // window.fbAsyncInit = function () {
    //   FB.init({
    //     appId: process.env.FACEBOOK_APP_ID,
    //     xfbml: true,
    //     version: 'v2.7'
    //   })
    //   FB.getLoginStatus(function (response) {
    //     console.log(response)
    //   })
    // };
    // // eslint-disable-next-line
    // (function(d, s, id) {
    //   // eslint-disable-next-line
    //   var js, fjs = d.getElementsByTagName(s)[0];
    //   if (d.getElementById(id)) {
    //     return
    //   }
    //   js = d.createElement(s)
    //   js.id = id
    //   js.src = '//connect.facebook.net/en_US/sdk.js'
    //   fjs.parentNode.insertBefore(js, fjs)
    // }(document, 'script', 'facebook-jssdk'))
  },
  components: {
    App
  },
  template: '<App/>',
  data: {
    environment: process.env.NODE_ENV,
    stripeKey: process.env.STRIPE_KEY,
    apiBase: process.env.API_BASE,
    // stripeYearlyPlanID: process.env.STRIPE_YEARLY_PLAN_ID,
    // stripeMonthlyPlanID: process.env.STRIPE_MONTHLY_PLAN_ID,
    stripeLocale: {
      AU: {
        flag: '🇦🇺',
        currency: process.env.STRIPE_AU_LOCAL_CURRENCY,
        yearly: {
          type: 'yearly',
          id: process.env.STRIPE_AU_YEARLY_PLAN_ID,
          localCost: process.env.STRIPE_AU_YEARLY_COST_LOCAL,
          usdCost: process.env.STRIPE_AU_YEARLY_COST_USD
        }
      },
      GB: {
        flag: '🇬🇧',
        currency: process.env.STRIPE_GB_LOCAL_CURRENCY,
        yearly: {
          type: 'yearly',
          id: process.env.STRIPE_GB_YEARLY_PLAN_ID,
          localCost: process.env.STRIPE_GB_YEARLY_COST_LOCAL,
          usdCost: process.env.STRIPE_GB_YEARLY_COST_USD
        }
      },

      US: {
        flag: '🇺🇸',
        currency: process.env.STRIPE_US_LOCAL_CURRENCY,
        yearly: {
          type: 'yearly',
          id: process.env.STRIPE_US_YEARLY_PLAN_ID,
          localCost: process.env.STRIPE_US_YEARLY_COST_LOCAL,
          usdCost: process.env.STRIPE_US_YEARLY_COST_USD
        }
      },

      CA: {
        flag: '🇨🇦',
        currency: process.env.STRIPE_CA_LOCAL_CURRENCY,
        yearly: {
          type: 'yearly',
          id: process.env.STRIPE_CA_YEARLY_PLAN_ID,
          localCost: process.env.STRIPE_CA_YEARLY_COST_LOCAL,
          usdCost: process.env.STRIPE_CA_YEARLY_COST_USD
        }
      },
      HK: {
        flag: '🇭🇰',
        currency: process.env.STRIPE_HK_LOCAL_CURRENCY,
        yearly: {
          type: 'yearly',
          id: process.env.STRIPE_HK_YEARLY_PLAN_ID,
          localCost: process.env.STRIPE_HK_YEARLY_COST_LOCAL,
          usdCost: process.env.STRIPE_HK_YEARLY_COST_USD
        }
      },
      SG: {
        flag: '🇸🇬',
        currency: process.env.STRIPE_SG_LOCAL_CURRENCY,
        yearly: {
          type: 'yearly',
          id: process.env.STRIPE_SG_YEARLY_PLAN_ID,
          localCost: process.env.STRIPE_SG_YEARLY_COST_LOCAL,
          usdCost: process.env.STRIPE_SG_YEARLY_COST_USD
        }
      }
    }
  },
  mounted () {

  }
})



// WEBPACK FOOTER //
// ./src/main.js